module.exports = __webpack_public_path__ + "static/img/4.d758083.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/sp/4.png
// module id = o3N+
// module chunks = 0